import LayoutHorizontalSidenav from '@/layout/LayoutHorizontalSidenav'

export default [{
  path: '/account-settings',
  component: LayoutHorizontalSidenav,
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      component: () => import('@/components/profile/AccountSettings'),
      props: true,
      name: 'Profile'
    }
  ]
}]
